import {
  getAnalyticsAdminSettings,
  getAnalyticsAdminSettingsStatus,
  isOverallSentimentInLeadershipActivityEnabled,
  isSentimentPerTopThemeInLeadershipActivityEnabled,
  isSentimentPerTopThreadInLeadershipActivityEnabled,
  isTimeSavedAndPeopleHelpedInNetworkQuestionActivityEnabled,
  isTopThreadStarterSendersInCampaignActivityEnabled,
  isViewerCanEditSettings,
} from '@ms/yammer-data/dist/domains/analyticsAdminSettings/selectors';

import { useSelector } from '../useSelector';

type UseOverallSentimentInLeadershipActivityValue = () => boolean;
export const useOverallSentimentInLeadershipActivityValue: UseOverallSentimentInLeadershipActivityValue = () =>
  useSelector((state) => !!isOverallSentimentInLeadershipActivityEnabled(state));

type UseSentimentPerTopThemeInLeadershipActivityValue = () => boolean;
export const useSentimentPerTopThemeInLeadershipActivityValue: UseSentimentPerTopThemeInLeadershipActivityValue = () =>
  useSelector((state) => !!isSentimentPerTopThemeInLeadershipActivityEnabled(state));

type UseSentimentPerTopThreadInLeadershipActivityValue = () => boolean;
export const useSentimentPerTopThreadInLeadershipActivityValue: UseSentimentPerTopThreadInLeadershipActivityValue =
  () => useSelector((state) => !!isSentimentPerTopThreadInLeadershipActivityEnabled(state));

type UseTopThreadStarterSendersInCampaignActivityValue = () => boolean;
export const useTopThreadStarterSendersInCampaignActivityValue: UseTopThreadStarterSendersInCampaignActivityValue =
  () => useSelector((state) => !!isTopThreadStarterSendersInCampaignActivityEnabled(state));

type UseTimeSavedAndPeopleHelpedInNetworkQuestionActivityValue = () => boolean;
export const useTimeSavedAndPeopleHelpedInNetworkQuestionActivityValue: UseTimeSavedAndPeopleHelpedInNetworkQuestionActivityValue =
  () => useSelector((state) => !!isTimeSavedAndPeopleHelpedInNetworkQuestionActivityEnabled(state));

type UseViewerCanEditSettingsValue = () => boolean;
export const useViewerCanEditSettingsValue: UseViewerCanEditSettingsValue = () =>
  useSelector((state) => !!isViewerCanEditSettings(state));

type UseAnalyticsAdminSettings = () => ReturnType<typeof getAnalyticsAdminSettings>;
export const useAnalyticsAdminSettings: UseAnalyticsAdminSettings = () => useSelector(getAnalyticsAdminSettings);

type UseAnalyticsAdminSettingsStatus = () => ReturnType<typeof getAnalyticsAdminSettingsStatus>;
export const useAnalyticsAdminSettingsStatus: UseAnalyticsAdminSettingsStatus = () =>
  useSelector((state) => getAnalyticsAdminSettingsStatus(state));
